import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Simple documentation display component that renders documentation content and provides the current date for templates.
 * Exposes a read-only 'currentDate' getter which returns the current locale date string; no inputs or outputs are defined.
 * @component
 * @selector app-docs
 * @example
 *   <app-docs></app-docs>
 * @input none N/A - This component does not define any @Input properties.
 * @output none N/A - This component does not emit any @Output events.
 * Key methods:
 *   - get currentDate(): string - Read-only getter returning new Date().toLocaleDateString() for display in the template.
 * Lifecycle:
 *   - constructor() - Default constructor only; the component does not implement additional Angular lifecycle hooks (e.g., ngOnInit/ngOnDestroy).
 */
@Component({
  selector: 'app-docs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './docs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./docs.component.scss'],
})
export class DocsComponent {
  constructor() {}

  get currentDate(): string {
    return new Date().toLocaleDateString();
  }
}
